<script>
  import { createEventDispatcher } from 'svelte';
  import { auth } from '../../stores/auth';
  import { navigate } from 'svelte-routing';

  const dispatch = createEventDispatcher();

  let username = '';
  let password = '';
  let loading = false;
  let error = '';

  async function handleSubmit() {
    if (loading || !username || !password) return;

    loading = true;
    error = '';

    // Trim whitespace
    username = username.trim();

    try {
      const response = await auth.login(username, password, true);
      if (response?.access) {
        password = '';
        dispatch('success');
        await navigate('/', { replace: true });
      } else {
        error = 'Login failed. Please check your credentials.';
      }
    } catch (e) {
      console.error('Login error:', e);
      // Provide user-friendly error messages
      if (e.message.includes('401')) {
        error = 'Invalid username or password';
      } else if (e.message.includes('403')) {
        error = 'Your account is inactive';
      } else if (e.message.includes('Network')) {
        error = 'Network error. Please check your connection.';
      } else {
        error = e.message || 'Login failed. Please try again.';
      }
    } finally {
      loading = false;
    }
  }
</script>

<form on:submit|preventDefault={handleSubmit}>
  <div class="field">
    <label for="username">Username</label>
    <input
      type="text"
      id="username"
      bind:value={username}
      placeholder="Enter username"
      disabled={loading}
      required
    />
  </div>

  <div class="field">
    <label for="password">Password</label>
    <input
      type="password"
      id="password"
      bind:value={password}
      placeholder="Enter password"
      disabled={loading}
      required
    />
  </div>

  {#if error}
    <div class="error">{error}</div>
  {/if}

  <button type="submit" disabled={loading || !username || !password}>
    {loading ? 'Signing in...' : 'Sign In'}
  </button>
</form>

<style>
  form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  label {
    font-size: 13px;
    font-weight: 500;
    color: #374151;
  }

  input {
    width: 100%;
    padding: 12px 14px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 15px;
    background: #fff;
    transition: border-color 0.15s, box-shadow 0.15s;
  }

  input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  input:disabled {
    background: #f8fafc;
    cursor: not-allowed;
  }

  .error {
    padding: 12px;
    background: #fef2f2;
    color: #dc2626;
    border-radius: 8px;
    font-size: 13px;
    text-align: center;
  }

  button {
    width: 100%;
    padding: 14px;
    background: #3b82f6;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s;
  }

  button:hover:not(:disabled) {
    background: #2563eb;
  }

  button:disabled {
    background: #94a3b8;
    cursor: not-allowed;
  }
</style>
